
import createFeatureManagementInstance from '@justeat/feature-management';
import axios from "axios";

const sixtySeconds = 60 * 1000;
const fiveSeconds = 5000;

class JetFmLog {
  info(message, tags, payload = {}) {
    console.info("[jetfm]", message, tags, payload);
  }

  warn(message, tags, payload = {}) {
    console.warn("[jetfm]", message, tags, payload);
  }
}

export class JetFm {
  constructor() {
    this.service = null;
  }


  init() {
    const config = 
    {
      keyPrefix: 'jet-minisites',
      cdn: {
        host: 'https://features.api.justeattakeaway.com',
        scope: 'jet-minisites',
        environment: process.env.NODE_ENV || 'production',
        key: '',
        poll: true,
        pollInterval: sixtySeconds, // default value in docs
      },
      contextGetter: () => {    
        return { anonUserId: getOrderModuleUniqueId('order_module_uid') };
      },
      onTrack: (key, variant) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'experiment_active',
          tms_data: {
              eventData: {
                  experiment_variant: variant,
                  experiment_key: key,
              }
          }
      })
      },
    };

    config.log = new JetFmLog();
    const httpClient = axios.create({
      timeout: fiveSeconds
  });

const service = createFeatureManagementInstance(config, httpClient);
const self = this;
service.loadFromCdn()
    .then(() => {
        self.service = service;        
        self.service.getBooleanValue("feature_show_ordermodule");
        return self;
    })
    .catch(() => {
      // Silently fail
  });
  }
}

function getOrderModuleUniqueId(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
          return cookie.substring(nameEQ.length, cookie.length);
      }
  }
  return null;
}